module.exports = __webpack_public_path__ + "img/syy.1c8262c8.svg";